import React from 'react';

const Tool01Panel = ({ toolProps, onUpdate, downloadSVG }) => {
  const {
    circleCount,
    minRadius,
    spacing,
    baseFontSize,
    fontSizeDecreaseFactor,
    fontWeight,
    colors,
    svgWidth,
    svgHeight
  } = toolProps;

  const handleChange = (key, value) => {
    onUpdate(key, value);
  };

  return (
    <div className="panel">
      <h2>Natural History Museum Logo</h2>
      <div className="panel-controls">
        <div className="control-group">
          <label>Number of Circles:</label>
          <div className="slider-group">
            <input
              type="range"
              min="3"
              max="7"
              value={circleCount}
              onChange={(e) => handleChange('circleCount', Number(e.target.value))}
            />
            <span>{circleCount}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Minimum Radius:</label>
          <div className="slider-group">
            <input
              type="range"
              min="40"
              max="200"
              value={minRadius}
              onChange={(e) => handleChange('minRadius', Number(e.target.value))}
            />
            <span>{minRadius}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Spacing:</label>
          <div className="slider-group">
            <input
              type="range"
              min="20"
              max="100"
              value={spacing}
              onChange={(e) => handleChange('spacing', Number(e.target.value))}
            />
            <span>{spacing}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Base Font Size:</label>
          <div className="slider-group">
            <input
              type="range"
              min="10"
              max="100"
              value={baseFontSize}
              onChange={(e) => handleChange('baseFontSize', Number(e.target.value))}
            />
            <span>{baseFontSize}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Font Size Decrease Factor:</label>
          <div className="slider-group">
            <input
              type="range"
              min="0"
              max="10"
              value={fontSizeDecreaseFactor}
              onChange={(e) => handleChange('fontSizeDecreaseFactor', Number(e.target.value))}
            />
            <span>{fontSizeDecreaseFactor}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Font Weight:</label>
          <div className="slider-group">
            <input
              type="range"
              min="100"
              max="600"
              step="100"
              value={fontWeight}
              onChange={(e) => handleChange('fontWeight', Number(e.target.value))}
            />
            <span>{fontWeight}</span>
          </div>
        </div>

        <div className="control-group">
          <label>SVG Width:</label>
          <div className="slider-group">
            <input
              type="range"
              min="300"
              max="1660"
              value={svgWidth}
              onChange={(e) => handleChange('svgWidth', Number(e.target.value))}
            />
            <span>{svgWidth}</span>
          </div>
        </div>

        <div className="control-group">
          <label>SVG Height:</label>
          <div className="slider-group">
            <input
              type="range"
              min="300"
              max="1070"
              value={svgHeight}
              onChange={(e) => handleChange('svgHeight', Number(e.target.value))}
            />
            <span>{svgHeight}</span>
          </div>
        </div>

        <div className="control-group">
          <label>Colors:</label>
          <div className="color-group">
            {colors.map((color, index) => (
              <input
                key={index}
                type="color"
                value={color}
                onChange={(e) => {
                  const newColors = [...colors];
                  newColors[index] = e.target.value;
                  handleChange('colors', newColors);
                }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="panel-footer">
        {/* Use the passed `downloadSVG` function for the download action */}
        <button className="action-btn" onClick={downloadSVG}>
          Download SVG
        </button>
      </div>
    </div>
  );
};

export default Tool01Panel;
